import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { StyledComponentProps as _StyledComponentProps } from "styled-components";
var _excluded = ["Icon"];
import React from "react";
export var DynamicIcon = /*#__PURE__*/React.forwardRef(function Icon(props, ref) {
  var Icon = props.Icon,
      restProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, restProps));
});
//# sourceMappingURL=DynamicIcon.js.map